import React from 'react';

import Button from '@atlaskit/button/button';

const ButtonDefaultExample = (): React.JSX.Element => {
	return <Button>Default button</Button>;
};

export default ButtonDefaultExample;
